import { getObject } from './getObject';
import { saveObject } from './saveObject';

function getItem(key: string): string {
  return localStorage.getItem(key) ?? '';
}

function setItem(key: string, value: string) {
  localStorage.setItem(key, value);
}

function deleteItem(key: string) {
  localStorage.removeItem(key);
}

export { deleteItem, getItem, getObject, saveObject, setItem };
